// extracted by mini-css-extract-plugin
export default {"vertical_bar_scale":"scale_vertical_bar_scale__V2ux-","vertical_bar_scale_wrapper":"scale_vertical_bar_scale_wrapper__5KxGF"};